module.exports = __webpack_public_path__ + "static/media/UniviaPro-Bold.4f2d8a5b.otf";